import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "chat"
};
var _hoisted_2 = {
  key: 2,
  style: {
    "line-height": "40px",
    "text-align": "center",
    "border-top": "1px solid #ccc"
  }
};
import TUIChatEngine, { TUITranslateService, TUIConversationService, TUIStore, StoreName, TUIGroupService } from '@tencentcloud/chat-uikit-engine';
import TUICore, { TUIConstants } from '@tencentcloud/tui-core';
import { ref, onUnmounted } from '../../adapter-vue';
import ChatHeader from '@/TUIKit/components/TUIChat/chat-header/index.vue';
import MessageList from './message-list/index.vue';
import MessageInput from './message-input/index.vue';
import Forward from './forward/index.vue';
import MessageInputToolbar from './message-input-toolbar/index.vue';
import { isPC, isWeChat, isUniFrameWork } from '../../utils/env';
import TUIChatConfig from './config';
import { useUserStore } from '@/store/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['closeChat'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var userStore = useUserStore();
    var emits = __emit;
    var isToolbarShow = ref(!isUniFrameWork);
    var messageInputRef = ref();
    var currentConversationID = ref();
    // 是否显示群组管理
    var isGroup = ref(false);
    var groupID = ref('');
    var groupManageExt = ref(undefined);
    var errorTitle = ref('');
    var showInput = ref(true);
    TUIStore.watch(StoreName.CONV, {
      currentConversation: conversation => {
        var _conversation$groupPr, _conversation$groupPr2;
        // console.log("conversatioyuejie->", conversation)
        if (currentConversationID.value === (conversation === null || conversation === void 0 ? void 0 : conversation.conversationID)) {
          return;
        }
        // TUIChat 每次切换会话，需要初始化 chatType;
        TUIChatConfig.setChatType(conversation === null || conversation === void 0 ? void 0 : conversation.type);
        // 由 TUICustomerServicePlugin 插件判断如果当前会话是客服会话，则设置 chatType 并激活会话。
        TUICore.callService({
          serviceName: TUIConstants.TUICustomerServicePlugin.SERVICE.NAME,
          method: TUIConstants.TUICustomerServicePlugin.SERVICE.METHOD.ACTIVE_CONVERSATION,
          params: {
            conversationID: conversation === null || conversation === void 0 ? void 0 : conversation.conversationID
          }
        });
        currentConversationID.value = conversation === null || conversation === void 0 ? void 0 : conversation.conversationID;
        isGroup.value = (conversation === null || conversation === void 0 ? void 0 : conversation.type) === TUIChatEngine.TYPES.CONV_GROUP;
        if (isUniFrameWork && isGroup.value && groupID.value !== (conversation === null || conversation === void 0 || (_conversation$groupPr = conversation.groupProfile) === null || _conversation$groupPr === void 0 ? void 0 : _conversation$groupPr.groupID)) {
          var extList = TUICore.getExtensionList(TUIConstants.TUIChat.EXTENSION.CHAT_HEADER.EXT_ID, {
            filterManageGroup: !isGroup.value
          });
          groupManageExt.value = extList[0];
        }
        if (isUniFrameWork && !isGroup.value) {
          groupManageExt.value = undefined;
        }
        groupID.value = conversation === null || conversation === void 0 || (_conversation$groupPr2 = conversation.groupProfile) === null || _conversation$groupPr2 === void 0 ? void 0 : _conversation$groupPr2.groupID;
        if (groupID.value && conversation) {
          console.log("groupID.value->", groupID.value);
          TUIGroupService.getGroupMemberProfile({
            groupID: groupID.value,
            userIDList: [userStore.info.name] // 请注意：即使只拉取一个群成员的资料，也需要用数组类型，例如：userIDList: ['user1']
          }).then(res => {
            console.log("res----获取群组信息>", res);
            showInput.value = true;
            errorTitle.value = '';
          }).catch(err => {
            showInput.value = false;
            if (err.code == 10010) {
              errorTitle.value = '该群组已经被解散';
            } else if (err.code == 10007) {
              errorTitle.value = '您已退出该群组';
            }
            console.log("获取群组信息失败", err);
          });
        }
      }
    });
    onUnmounted(() => {
      reset();
    });
    // 清空当前 conversationID
    var reset = () => {
      TUIConversationService.switchConversation();
    };
    var closeChat = conversationID => {
      emits('closeChat', conversationID);
      reset();
    };
    var insertEmoji = emojiObj => {
      var _messageInputRef$valu;
      messageInputRef === null || messageInputRef === void 0 || (_messageInputRef$valu = messageInputRef.value) === null || _messageInputRef$valu === void 0 || _messageInputRef$valu.insertEmoji(emojiObj);
    };
    var handleToolbarListShow = show => {
      if (isUniFrameWork) {
        isToolbarShow.value = show === undefined ? !isToolbarShow.value : show;
      } else {
        isToolbarShow.value = true;
      }
    };
    var handleEditor = (message, type) => {
      var _message$payload;
      if (!message || !type) return;
      switch (type) {
        case 'reference':
          // todo
          break;
        case 'reply':
          // todo
          break;
        case 'reedit':
          if (message !== null && message !== void 0 && (_message$payload = message.payload) !== null && _message$payload !== void 0 && _message$payload.text) {
            var _messageInputRef$valu2, _message$payload2;
            messageInputRef === null || messageInputRef === void 0 || (_messageInputRef$valu2 = messageInputRef.value) === null || _messageInputRef$valu2 === void 0 || _messageInputRef$valu2.reEdit(message === null || message === void 0 || (_message$payload2 = message.payload) === null || _message$payload2 === void 0 ? void 0 : _message$payload2.text);
          }
          break;
        default:
          break;
      }
    };
    var handleGroup = () => {
      groupManageExt.value.listener.onClicked({
        groupID: groupID.value
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
      }, [!_unref(currentConversationID) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['tui-chat-default', !_unref(isPC) && 'tui-chat-h5-default'])
      }, [_renderSlot(_ctx.$slots, "default")], 2)) : _createCommentVNode("", true), _unref(currentConversationID) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['tui-chat', !_unref(isPC) && 'tui-chat-h5'])
      }, [_createVNode(ChatHeader, {
        class: _normalizeClass(['tui-chat-header', !_unref(isPC) && 'tui-chat-H5-header', _unref(isUniFrameWork) && 'tui-chat-uniapp-header']),
        onCloseChat: closeChat
      }, null, 8, ["class"]), _createVNode(Forward), _createVNode(MessageList, {
        class: _normalizeClass(['tui-chat-message-list', !_unref(isPC) && 'tui-chat-h5-message-list']),
        isGroup: _unref(isGroup),
        groupID: _unref(groupID),
        onHandleEditor: handleEditor
      }, null, 8, ["class", "isGroup", "groupID"]), _unref(isToolbarShow) && _unref(showInput) ? (_openBlock(), _createBlock(MessageInputToolbar, {
        key: 0,
        class: _normalizeClass(['tui-chat-message-input-toolbar', !_unref(isPC) && 'tui-chat-h5-message-input-toolbar', _unref(isUniFrameWork) && 'tui-chat-uni-message-input-toolbar']),
        onInsertEmoji: insertEmoji
      }, null, 8, ["class"])) : _createCommentVNode("", true), _unref(showInput) ? (_openBlock(), _createBlock(MessageInput, {
        key: 1,
        ref_key: "messageInputRef",
        ref: messageInputRef,
        class: _normalizeClass(['tui-chat-message-input', !_unref(isPC) && 'tui-chat-h5-message-input', _unref(isUniFrameWork) && 'tui-chat-uni-message-input', _unref(isWeChat) && 'tui-chat-wx-message-input']),
        isMuted: false,
        muteText: _unref(TUITranslateService).t('TUIChat.您已被管理员禁言'),
        placeholder: _unref(TUITranslateService).t('TUIChat.请输入消息'),
        onHandleToolbarListShow: handleToolbarListShow
      }, null, 8, ["class", "muteText", "placeholder"])) : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(errorTitle)), 1))], 2)) : _createCommentVNode("", true), _unref(isUniFrameWork) && _unref(isGroup) && _unref(groupManageExt) ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "group-profile",
        onClick: handleGroup
      }, _toDisplayString(_unref(groupManageExt).text), 1)) : _createCommentVNode("", true)], 2)]);
    };
  }
});